



































































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import useWindowResize from '~/hooks/useResizeWindow';
import {
  addCurrency,
  getCurrencyAffixes,
  getPriceParts,
  priceFormat
} from '~/helpers/utils';

type Service = {
  thumbnail: string;
  alt?: string;
  type: string;
  description?: string;
  price?: number;
  priceDifference?: number;
  duration?: string;
  ctaText: string;
  isGreen?: boolean;
  link: string;
  target: string;
};

export default defineComponent({
  name: 'AdditionalServices',
  props: {
    services: {
      type: Array as PropType<Service[]>,
      required: true,
      default: () => []
    }
  },
  setup() {
    const isDesktop = useWindowResize();
    const { translate } = useTranslations();

    const currencyAffixes = computed(() => getCurrencyAffixes());

    return {
      addCurrency,
      currencyAffixes,
      getPriceParts,
      translate,
      priceFormat,
      isDesktop
    };
  }
});
